import React, {useEffect, useState} from "react";
import searchImg from "../../resources/images/app/ui/search.svg";
import cancelImg from "../../resources/images/icons/cancel.svg";
import {emptyString} from "../../utils/stringUtils";
import useResizeObserver from "../../hooks/useResizeObserver";

export default function SearchInput({ amount = 0, allAmount = 0, label = "Показано:", onTextTyping, searchValue, width }) {

    const labelClassName = allAmount === amount ? "txt-search" : "txt";
    const amountData = allAmount === amount ? allAmount : (amount + "/" + allAmount);
    const [value, setValue] = useState("");

    const tabsEl = document.getElementById("nav-tab");
    const tabsObserver = useResizeObserver(tabsEl);

    const headerBtnsEl = document.getElementById("contentHeaderBtnsBlock");
    const headerBtnsWidth = headerBtnsEl?.offsetWidth || 0;

    const capButtonEl = document.getElementById("capButton");
    const capButtonWidth = capButtonEl?.offsetWidth || 0;

    const contentHeaderEl = document.getElementById("contentHeader");
    const contentHeaderWidth = contentHeaderEl?.offsetWidth || 0;
    const searchInputWidth = contentHeaderWidth - tabsObserver.width - headerBtnsWidth - capButtonWidth - 50;


    useEffect(() => {
        if (emptyString(searchValue)) {
            return;
        }
        setValue(searchValue);
    }, []);

    const handleTextTyping = (val) => {
        setValue(val);
        onTextTyping(val);
    };


    return (

        <div className="search open" id="searchInput" style={{width : (width || searchInputWidth + "px")}}>
            <div className="icon-search">
                {value
                    ? <img src={cancelImg} alt="" className="top-search-clear" onClick={() => handleTextTyping("")}/>
                    : <img src={searchImg} alt="" className="src" />
                }
            </div>
            <input
                type="search"
                placeholder="Искать..."
                className="top-search"
                onChange={(e) => handleTextTyping(e.target.value)}
                value={value}
            />
                <div className="results">
                    <div className={labelClassName}>
                        {label}
                    </div>
                    <div className="amount">{amountData}</div>
                </div>
        </div>
    )
}
